module.exports = __webpack_public_path__ + "img/Edit.5585c8f7.svg";